'use strict'

module.exports = {
  '+': 'positive',
  '-': 'negative',
  '~': 'oneComplement'
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-codegen/lib/misc/UnaryOperators.js
// module id = dl1g
// module chunks = 0